<svg id="Layer_1" data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <title>rewind-glyph</title>
    <path d="M481.76,510.43c17,0,30.24-13.78,30.24-31.36V32.93c0-17.58-13.28-31.36-30.25-31.36a32.73,32.73,0,0,0-16.3,4.49L128.61,229.12C118.54,234.93,112.53,245,112.53,256s6,21.07,16.08,26.87L465.45,505.94a32.72,32.72,0,0,0,16.3,4.49Z" fill="currentColor"/>
    <path d="M61.94,499.51a61.94,61.94,0,0,0,61.94-61.93V74.42A61.94,61.94,0,0,0,0,74.42V437.58A61.94,61.94,0,0,0,61.94,499.51Z" fill="currentColor"/>
</svg>